import {useEffect, useState} from "react";
import {InfoContainer, TitleContainer} from "./components";
import {Avatar, Button, Grid, styled, Typography} from "@mui/material";
import ApiIcon from "assets/icons/businessInfo/ApiIcon";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import DevicesIcon from "@mui/icons-material/Devices";
import DownloadIcon from "assets/icons/DownloadIcon";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {apiDeleteOffline, apiDownloadConfig} from "../../../api/offlineApi";
import {setConfirm} from "../../../store/actions/appAction";
import filledIcon from "assets/images/filledIcon.png";
import emptyIcon from "assets/images/emptyIcon.png";
import Hint from "../../Shared/Hint";
import {apiGetBusiness} from "../../../api/businessApi";

const NotAvailableContainer = styled("div")(({theme}) => ({
    width: "100%",
    display: "flex",
    justifyContent: "center",
}));
const StyledButton = styled(Button)(({theme}) => ({
    width: "144px",
    height: "44px",
    borderRadius: "4px",
}));

export const NotAvailable = ({handleClick}: { handleClick: () => void }) => {
    return (
      <NotAvailableContainer>
          <StyledButton
            onClick={() => handleClick()}
            startIcon={<ShoppingCartOutlinedIcon/>}
            disableRipple
            color="primary"
            variant="outlined"
          >
              &nbsp; ارتقاء اشتراک
          </StyledButton>
      </NotAvailableContainer>
    );
};

const InitialteInstallContainer = styled("div")(({theme}) => ({
    width: "100%",
    display: "flex",
    justifyContent: "center",
}));

const InitialteInstallItems = styled("div")(({theme}) => ({
    height: "316px",
    width: "100%",
    backgroundColor: "white",
    boxShadow: "0px -1px 20px rgba(159, 166, 176, 0.11)",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: "24px",
    paddingBottom: "24px",
}));
const InitialItemIcon = styled("div")(({theme}) => ({
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    padding: "5px",
}));

const ItemAvatar = styled(Avatar)(({theme}) => ({
    width: "100px",
    height: "100px",
    borderRadius: "4px",
}));
const ItemBadge = styled("div")(({theme}) => ({
    position: "absolute",
    bottom: -14,
    right: -16,
    zIndex: 1000,
}));

const DownloadButton = styled(Button)(({theme}) => ({
    width: "180px",
    height: "44px",
    borderRadius: "4px",
}));

const InitialteInstall = ({handleClick}: { handleClick: () => void }) => {
    const dispatch = useDispatch();
    // @ts-ignore
    const {token} = useSelector((state) => state).businessReducer.business;
    return (
      <>
          <Hint message={
              <div>
                  <p>در صورتیکه برای اولین بار میخواهید نصب نسخه آفلاین چرتکه را انجام دهید، ابتدا فایل نصب را دانلود
                      کرده و در محل دلخواه نصب نمایید. سپس فایل فعالسازی را دانلود کرده و در پوشه محل نصب نسخه آفلاین
                      چرتکه کپی نمایید. سپس نسخه آفلاین چرتکه را باز کرده و روی گزینه فعالسازی کلیک کنید.</p>
                  <p className='mt-3'>در صورتیکه چرتکه آفلاین را نصب کرده اید و تنها قصد بروزرسانی نرم افزار خود را
                      دارید، فایل بروزرسانی را دانلود کرده و در پوشه محل نصب برنامه کپی کرده و سپس از حالت فشرده خارج
                      نمایید.</p>
              </div>
          }/>
          <InitialteInstallContainer>
              <Grid container maxWidth="lg" spacing={4}>
                  <Grid item xs={4}>
                      <InitialteInstallItems>
                          <ItemAvatar src={filledIcon}/>
                          <Typography color="#00367E">فایل نصب چرتکه</Typography>
                          <DownloadButton
                            startIcon={<DownloadIcon primary={true}/>}
                            disableRipple
                            color="primary"
                            variant="outlined"
                          >
                              <a href="https://chortke.app/desktop/chortke-offline.exe" target="_blank"
                                 rel="noreferrer">
                                  &nbsp; دانلود فایل
                              </a>
                          </DownloadButton>
                      </InitialteInstallItems>
                  </Grid>
                  <Grid item xs={4}>
                      <InitialteInstallItems>
                          <InitialItemIcon>
                              <ItemAvatar src={emptyIcon}/>
                              <ItemBadge children={<Unbox/>}/>
                          </InitialItemIcon>
                          <Typography color="#00367E">فایل فعالسازی</Typography>
                          <DownloadButton
                            // @ts-ignore
                            onClick={() => dispatch(apiDownloadConfig(token))}
                            startIcon={<DownloadIcon primary={true}/>}
                            disableRipple
                            color="primary"
                            variant="outlined"
                          >
                              &nbsp; دانلود فایل
                          </DownloadButton>
                      </InitialteInstallItems>
                  </Grid>
                  <Grid item xs={4}>
                      <InitialteInstallItems>
                          <InitialItemIcon>
                              <ItemAvatar src={emptyIcon}/>
                              <ItemBadge children={<Update/>}/>
                          </InitialItemIcon>
                          <Typography color="#00367E">فایل بروزرسانی</Typography>
                          <DownloadButton
                            startIcon={<DownloadIcon primary={true}/>}
                            disableRipple
                            color="primary"
                            variant="outlined"
                          >
                              <a href="https://chortke.app/desktop/latest-update.rar" target="_blank"
                                 rel="noreferrer">
                                  &nbsp; دانلود فایل
                              </a>
                          </DownloadButton>
                      </InitialteInstallItems>
                  </Grid>
              </Grid>
          </InitialteInstallContainer>
      </>
    );
};

const AvailableDevicesContainer = styled("div")(({theme}) => ({
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #ABBACC",
    borderRadius: "4px",
    padding: "12px",
}));
const RightItem = styled("div")(({theme}) => ({
    display: "flex",
    heght: "100%",
    alignItems: "center",
}));

const DeviceContainer = styled("div")(({theme}) => ({
    display: "flex",
    alignItems: "center",

    justifyContent: "center",
    width: "42px",
    height: "42px",
    backgroundColor: "#EBF3FF",
}));
const RightItemDetails = styled("div")(({theme}) => ({
    paddingRight: "15px",
    height: "100%",
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
}));
const DetailsUpper = styled("div")(({theme}) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
}));

const AvailableDevices = () => {
    const dispatch = useDispatch();
    // @ts-ignore
    const business = useSelector((state) => state).businessReducer.business;

    const parseOfflineConfig = () => {
        let computerName, os, processorArchitecture, userName;
        let offlineConfig = business.user.offlineConfig;

        if (offlineConfig) {
            while (typeof offlineConfig === "string" && offlineConfig !== null) {
                offlineConfig = JSON.parse(offlineConfig);
            }

            computerName = offlineConfig.computerName ?? "";
            os = offlineConfig.os ?? "";
            processorArchitecture = offlineConfig.processorArchitecture ?? "";
            userName = offlineConfig.userName ?? "";

        }

        return {
            computerName,
            os,
            processorArchitecture,
            userName,
        };
    };

    const {computerName, os, processorArchitecture, userName} = parseOfflineConfig();

    return (
      <>
          <AvailableDevicesContainer>
              <RightItem>
                  <DeviceContainer>
                      <DevicesIcon color="primary"/>
                  </DeviceContainer>
                  <RightItemDetails>
                      <DetailsUpper>
                          <Typography color="text.primary">
                              {os} - {computerName}
                          </Typography>
                          <Typography color="text.disabled">({userName})</Typography>
                      </DetailsUpper>
                      <Typography color="text.disabled">{processorArchitecture}</Typography>
                  </RightItemDetails>
              </RightItem>
              <StyledButton
                onClick={() => {
                    // @ts-ignore
                    dispatch(
                      // @ts-ignore
                      setConfirm("دستگاه آفلاین", () => dispatch(apiDeleteOffline(business.token, business)))
                    );
                }}
                disableRipple
                color="error"
                variant="outlined"
              >
                  حذف این دستگاه
              </StyledButton>
          </AvailableDevicesContainer>
          <Typography className="p-2" style={{fontSize: 12, color: "#1062D0"}}>
              {" "}
              در صورت حذف مجوز دستگاه آفلاین، دیگر قادر به همگام سازی اطلاعات با نسخه آفلاین نخواهید بود!
          </Typography>
      </>
    );
};

const offlineItems = [
    {
        Component: NotAvailable,
        key: "not-available",
        description:
          "امکان استفاده آفلاین برای اشتراک شما فعال نشده است. برای فعالسازی باید اشتراک خود را ارتقاء دهید",
        showTitle: true,
    },
    {
        Component: InitialteInstall,
        key: "initiate-install",
        description: "",
    },
    {
        Component: AvailableDevices,
        key: "initiate-install",
        description: "نسخه آفلاین حساب کاربری شما روی دستگاه زیر فعال شده است:",
        showTitle: false,
    },
];

const ChortkeOffline = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // @ts-ignore
    const {business, token, user} = useSelector((state) => state).businessReducer.business;
    const [offlineStatus, setOfflineStatus] = useState(offlineItems[0]);
    const {Component, description, showTitle} = offlineStatus;

    useEffect(() => {
        //@ts-ignore
        dispatch(apiGetBusiness(business, token,undefined,true));
    }, [])

    useEffect(() => {
        if (!business.subscription || ![4, 10, 11, 12, 17, 18, 19, 20, 25, 26, 27, 28,30,32,34,36,37].includes(business.subscription.id)) {
            setOfflineStatus(offlineItems[0]);
        } else {
            if (user.offlineConfig) {
                setOfflineStatus(offlineItems[2]);
            } else {
                setOfflineStatus(offlineItems[1]);
            }
        }
    }, [business]);
    const handleProceed = () => {
        const currentIndex = offlineItems.findIndex((item) => item.key === offlineStatus.key);
        return setOfflineStatus(offlineItems[currentIndex + 1]);
    };
    return (
      <InfoContainer>
          {showTitle && (
            <TitleContainer>
                <ApiIcon/>
                <Typography sx={{marginRight: "10px"}} variant="body1">
                    چرتکه آفلاین
                </Typography>
            </TitleContainer>
          )}
          <Grid container>
              <Grid item xs={12}>
                  <Typography color="#666666" sx={{mb: 3}}>
                      {description}
                  </Typography>
              </Grid>
              <Component handleClick={handleProceed}/>
          </Grid>
      </InfoContainer>
    );
};

export default ChortkeOffline;

export const Update = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" fill="none" viewBox="0 0 40 38">
          <path
            fill="#1062D0"
            d="M4.916 7.364 4.217 4.44a1.834 1.834 0 0 0-1.88-1.436A1.834 1.834 0 0 0 .648 5.29l1.827 7.563a1.833 1.833 0 0 0 2.205 1.353l7.566-1.812c2.383-.578 1.516-4.151-.866-3.573l-3.638.877c2.518-3.18 6.23-5.403 10.592-5.869 8.625-.92 16.323 5.3 17.245 13.925.198 2.514 3.994 2.105 3.652-.393C38.17 7.429 29.713.032 18.943.133 12.62.758 8.024 3.471 4.916 7.364Zm22.809 18.187c-2.48.508-1.585 4.242.856 3.57l3.634-.877c-2.519 3.179-6.23 5.392-10.592 5.858A15.636 15.636 0 0 1 4.383 20.19a1.834 1.834 0 0 0-1.87-1.665 1.834 1.834 0 0 0-1.772 2.06C1.872 31.18 11.418 38.888 22.014 37.756c5.33-.568 9.921-3.29 13.03-7.179l.709 2.93c.446 2.563 4.322 1.635 3.56-.853l-1.816-7.566c-.207-.873-1.014-1.468-2.065-1.38l-7.707 1.842Z"
          />
      </svg>
    );
};
export const Unbox = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" fill="none" viewBox="0 0 45 44">
          <path
            fill="#1062D0"
            d="M44.101 21.024c-5.651-5.638-5.5-5.597-5.871-5.762l-9.625-4.386a1.377 1.377 0 0 0-2.016 1.196 1.375 1.375 0 0 0 .888 1.307l6.875 3.121L22.5 21.863 10.702 16.5l6.875-3.121a1.375 1.375 0 0 0-1.127-2.503c-6.696 3.039-9.804 4.469-9.625 4.386-.33.165-.165 0-5.885 5.762a1.376 1.376 0 0 0 .412 2.227l15.125 6.875a1.374 1.374 0 0 0 1.54-.275l3.108-3.162v13.75L8.75 34.87v-4.62a1.375 1.375 0 1 0-2.75 0c0 6.078 0 5.775.247 6.242.086.178.232.32.413.4.137.095 0 .068.179.123C23.31 44.495 22.074 44 22.499 44c.427 0-.687.44 15.69-6.999a1.374 1.374 0 0 0 .81-1.251V25.383l4.69-2.132a1.375 1.375 0 0 0 .412-2.227Zm-27.404 6.201L4.322 21.574l3.355-3.424 12.444 5.651-3.424 3.424ZM36.25 34.87l-12.375 5.624v-13.75C27.257 30.07 27.244 30.25 28 30.25c.454 0 .096.096 8.25-3.616v8.236Zm-7.948-7.645-3.423-3.424 12.443-5.651 3.424 3.424-12.444 5.651Z"
          />
          <path
            fill="#69AAFC"
            d="M27.601 4.524 23.476.399a1.375 1.375 0 0 0-1.953 0l-4.125 4.125a1.38 1.38 0 0 0 1.953 1.952l1.774-1.787v7.686a1.375 1.375 0 1 0 2.75 0V4.689l1.773 1.787a1.376 1.376 0 0 0 .977.399 1.375 1.375 0 0 0 .976-2.351Z"
          />
      </svg>
    );
};
